// Used in many components

import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "no-search-results",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ["no-search-results.component.scss"],
    template: `
        <div class="noResults">
            <div><img [src]="searchIcon" /></div>
            <div>
                <h3>No Results</h3>
            </div>
        </div>
    `,
    standalone: false
})
export class NoSearchResultsComponent {
    searchIcon = "./assets/images/share/searchIcon.svg";

    constructor() {}
}
